const cls = (...classNames) => classNames.join(' ');

export default cls;
